let e = null;
const o = /* @__PURE__ */ new Map();
let n = !1, s = null;
globalThis.storyCache = globalThis.storyCache ? globalThis.storyCache : /* @__PURE__ */ new Map();
const c = () => e, r = (t) => {
  e = t;
}, b = (t) => (Object.entries(t).forEach(([l, a]) => {
  o.set(l, a);
}), o), p = (t) => o.has(t) ? o.get(t) : (console.error(`Component ${t} doesn't exist.`), !1), C = () => n, m = (t) => {
  n = t;
}, i = () => s, k = (t) => {
  s = t;
};
export {
  p as getComponent,
  i as getCustomFallbackComponent,
  C as getEnableFallbackComponent,
  c as getStoryblokApiInstance,
  b as setComponents,
  k as setCustomFallbackComponent,
  m as setEnableFallbackComponent,
  r as setStoryblokApiInstance
};
